import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'


//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {DriverDetailsComponent} from '../../components/ControlGroups/DriverDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';

// export const BASE_REQUEST_ACCESSOR: any = {
//     provide: NG_VALUE_ACCESSOR,
//     useExisting: forwardRef(() => CreateDriverRequestComponent),
//     multi: true
// };

@Component({
  selector: 'my-createdriver-request',
  templateUrl: './CreateDriverRequest.component.html',
  providers: [{provide: BaseRequestComponent, useExisting: forwardRef(() => CreateDriverRequestComponent)}]
})
export class CreateDriverRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(DriverDetailsComponent) driverDetailsComponent: DriverDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.userInfoComponent.onSalesOfficeChange.subscribe((x: any) => this.userInfoSalesOfficeChange(x));
        
        
    }

    userInfoSalesOfficeChange(salesOffice: ent.SalesOffice) {

        var myAddress: ent.MyAddress = {
            ID: 0, 
            City: salesOffice.City, 
            State: salesOffice.State.Code, 
            Country: "US", 
            County: salesOffice.County, 
            HouseNumber: salesOffice.StreetNumber, 
            StreetName: salesOffice.StreetName,
            Lat: salesOffice.Latitude,
            Lng: salesOffice.Longitude,
            FormattedAddress: "",
            PostalCode: salesOffice.PostalCode,
            PlaceId: salesOffice.MapRefID,
            StreetAddress: ""
        };

        this.addressComponent.addressChanged(myAddress);
        this.addressComponent.disableAddressFormFields = true;
    }
    
    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            RequestTypeID: enums.RequestTypeEnum.Driver,
            DriverInfo: this.driverDetailsComponent.driverInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onSubmitClick(event: any){
        this.getRequest(true);
    }

}